import { actionTypes } from '../const';

const fraworkday = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.FRA_WORKDAY_SUCCESS:
            return Object.assign({}, state, {
                fraworkdays: action.workdays,
                isLoading: false
            });
            case actionTypes.FRA_WORKDAY_LOADING:
                return Object.assign({}, state, {                 
                    fraworkdays: {},   
                    isLoading: action.isLoading
                });
        default:
            return state;
    }
}
export default fraworkday